import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import { IGenerateOtpRequest, IGenerateOtpResponse } from '../models/generate-otp.model';

// Updating if user is locked
export const loadGenerateOtpRequest = createAction('[GenerateOtp] Load GenerateOtp request', props<{ request: IGenerateOtpRequest }>());

export const loadGenerateOtpResponse = createAction('[GenerateOtp] Load GenerateOtp Success', props<{ response: IGenerateOtpResponse }>());

export const loadGenerateOtpFailure = createAction(
  '[GenerateOtp] Load GenerateOtp Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
